import { TableCell, TableHead, TableRow, TableSortLabel, Tooltip } from "@material-ui/core"
import CloseIcon from "@material-ui/icons/Close"
import { smbcInstance } from "../../../shared_elements/components"

const EngineAssetHd = ({ sort, sort_by, createSortHandler }) => {
	const savedSorting = JSON.parse(localStorage.getItem('sortField') || '{}')

	const sortableCell = (key, label, width) => (
		<TableCell key={key} style={width ? { minWidth: width } : {}}>
			<TableSortLabel
				active={sort === key}
				direction={sort === key && sort_by ? sort_by : 'asc'}
				onClick={() => createSortHandler(key)}
			>
				{label}
			</TableSortLabel>
			{savedSorting?.sort === key && (
				<Tooltip title="Clear" arrow placement="top">
					<CloseIcon
						style={{ fontSize: '15px', color: "#6d9bb9", verticalAlign: 'middle' }}
						size="small"
						className="close-icon"
						onClick={() => createSortHandler('', true)}
					/>
				</Tooltip>
			)}
		</TableCell>
	)

	return (
		<TableHead className="mui-table">
			<TableRow>
				{smbcInstance ? (
					<>
						{sortableCell('engine_family', 'Engine Family and Type', 190)}
						{sortableCell('asset_name', 'ESN', 100)}
						<TableCell style={{ minWidth: 110 }}>A/C Reg.</TableCell>
						<TableCell style={{ minWidth: 80 }}>Position</TableCell>
						{sortableCell('lessee', 'Lessee', 100)}
						{sortableCell('operator', 'Operator', 100)}
						{sortableCell('status', 'Lease Status', 120)}
						<TableCell style={{ minWidth: 110 }}>Lease Expiry Date</TableCell>
						{sortableCell('on_wing_msn', 'Wing Status', 120)}
						<TableCell style={{ minWidth: 130 }}>Current Status</TableCell>
						<TableCell>Action</TableCell>
					</>
				) : (
					<>
						{sortableCell('engine_type', 'Type and Model', 120)}
						{sortableCell('asset_name', 'ESN', 110)}
						{sortableCell('lessor', 'Lessor', 120)}
						{sortableCell('owner', 'Owner', 120)}
						{sortableCell('lessee', 'Lessee', 120)}
						{sortableCell('status', 'Lease Status', 110)}
						{sortableCell('on_wing_msn', 'Current Status', 110)}
						<TableCell style={{ minWidth: 40 }}>Action</TableCell>
					</>
				)}
			</TableRow>
		</TableHead>
	)
}

export default EngineAssetHd
